import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/helpers/auth.service';

@Component({
  selector: 'loyaltic-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  currentPath = '';
  private subscriptions: Subscription[] = [];

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.isLoggedIn = this.authService.IsLoggedIn();
    this.currentPath = this.getPath(this.router.url);

    this.subscriptions.push(
      this.authService.loginEmitter.subscribe((response: boolean) => {
        this.isLoggedIn = !!response && this.authService.IsLoggedIn();
      })
    );

    this.subscriptions.push(
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentPath = this.getPath(event.urlAfterRedirects || this.router.url);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private getPath(url: string): string {
    return (url || '').split('?')[0].split('#')[0] || '/';
  }
}
